import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  BooleanField,
  BooleanInput,
  DateField,
  DateInput,
  Resource,
  Show,
  SimpleShowLayout,
  Datagrid,
  EditButton,
  required,
} from "react-admin";

const CircularityVersionList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" label="Version ID" />
      <TextField source="circularity_version_name" label="Circularity version name" />
      <BooleanField source="active" label="Active" />
      <DateField source="release_date" label="Release Date" />
      <EditButton />
    </Datagrid>
  </List>
);

const CircularityVersionShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Version ID" />
      <TextField source="circularity_version_name" label="Circularity version name" />
      <BooleanField source="active" label="Active" />
      <DateField source="release_date" label="Release Date" />
    </SimpleShowLayout>
  </Show>
);

const CircularityVersionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="circularity_version_name" label="Circularity version name" validate={required()} />
      <BooleanInput source="active" label="Active" />
      <DateInput source="release_date" label="Release Date" />
    </SimpleForm>
  </Create>
);

const CircularityVersionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="id" label="Version ID" />
      <TextInput source="circularity_version_name" label="Circularity version name" validate={required()} />
      <BooleanInput source="active" label="Active" />
      <DateInput source="release_date" label="Release Date" />
    </SimpleForm>
  </Edit>
);

const circularityVersionResource = () => (
  <Resource
    name="circularityVersion"
    options={{ label: "Circularity Versions", menuGroup: "Bcome" }}
    list={CircularityVersionList}
    show={CircularityVersionShow}
    create={CircularityVersionCreate}
    edit={CircularityVersionEdit}
  />
);

export default circularityVersionResource;
